var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-var, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var _require = require("../icon-paths.js"),
    iconTrash = _require.iconTrash;

var Util = require("../util.js");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var BlurInput = require("react-components/blur-input.jsx");
var Editor = require("../editor.jsx");
var InfoTip = require("../components/info-tip.jsx");
var InlineIcon = require("../components/inline-icon.jsx");
var RangeInput = require("../components/range-input.jsx");

var defaultBoxSize = 400;
var defaultRange = [0, 10];
var defaultBackgroundImage = {
    url: null,
    width: 0,
    height: 0
};

// Match any image URL (including "web+graphie" links) that is hosted by KA.
// We're somewhat generous in our AWS URL matching
// ("ka-<something>.s3.amazonaws.com") so that we don't have to update Perseus
// every time we add a new proxied AWS bucket.
var INTERNALLY_HOSTED_DOMAINS = "(" + "ka-.*.s3.amazonaws.com|" + "(fastly|cdn).kastatic.org|" + "khanacademy.org|" + "kasandbox.org" + ")";
var INTERNALLY_HOSTED_URL_RE = new RegExp("^(https?|web\\+graphie)://[^/]*" + INTERNALLY_HOSTED_DOMAINS);

/**
 * Alignment option for captions, relative to specified coordinates.
 */
var captionAlignments = ["center", "above", "above right", "right", "below right", "below", "below left", "left", "above left"];

var ImageEditor = React.createClass({
    displayName: "ImageEditor",

    propTypes: _extends({}, Changeable.propTypes),

    componentDidMount: function componentDidMount() {
        var _this = this;

        // defer this because it can call a change handler synchronously
        _.defer(function () {
            var url = _this.props.backgroundImage.url;
            _this.onUrlChange(url, true);
        });
    },

    getDefaultProps: function getDefaultProps() {
        return {
            title: "",
            range: [defaultRange, defaultRange],
            box: [defaultBoxSize, defaultBoxSize],
            backgroundImage: defaultBackgroundImage,
            labels: [],
            alt: "",
            caption: ""
        };
    },

    getInitialState: function getInitialState() {
        return {
            backgroundImageError: ""
        };
    },

    render: function render() {
        var _this2 = this;

        var backgroundImage = this.props.backgroundImage;

        var imageSettings = React.createElement(
            "div",
            { className: "image-settings" },
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    React.createElement(
                        "div",
                        null,
                        "Alt text:",
                        React.createElement(
                            InfoTip,
                            null,
                            "This is important for screenreaders. The content of this alt text will be formatted as markdown (tables, emphasis, etc. are supported)."
                        )
                    ),
                    React.createElement(Editor, {
                        apiOptions: this.props.apiOptions,
                        content: this.props.alt,
                        onChange: function onChange(props) {
                            if (props.content != null) {
                                _this2.change("alt", props.content);
                            }
                        },
                        widgetEnabled: false
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    React.createElement(
                        "div",
                        null,
                        "Caption:"
                    ),
                    React.createElement(Editor, {
                        apiOptions: this.props.apiOptions,
                        content: this.props.caption,
                        onChange: function onChange(props) {
                            if (props.content != null) {
                                _this2.change("caption", props.content);
                            }
                        },
                        widgetEnabled: false
                    })
                )
            )
        );

        var backgroundImageErrorText = React.createElement(
            "div",
            { className: "renderer-widget-error" },
            this.state.backgroundImageError
        );

        return React.createElement(
            "div",
            { className: "perseus-image-editor" },
            React.createElement(
                "label",
                null,
                "Image url:",
                React.createElement(
                    InfoTip,
                    null,
                    "Paste an image or graphie image URL."
                ),
                this.state.backgroundImageError && backgroundImageErrorText,
                React.createElement(BlurInput, {
                    value: backgroundImage.url || "",
                    style: { width: 332 },
                    onChange: function onChange(url) {
                        return _this2.onUrlChange(url, false);
                    }
                })
            ),
            backgroundImage.url && imageSettings
        );
    },

    _renderRowForLabel: function _renderRowForLabel(label, i) {
        return React.createElement(
            "tr",
            { key: i },
            React.createElement(
                "td",
                null,
                React.createElement(RangeInput, {
                    value: label.coordinates,
                    onChange: this.onCoordinateChange.bind(this, i)
                })
            ),
            React.createElement(
                "td",
                { style: { verticalAlign: "bottom", width: "5px" } },
                React.createElement("input", {
                    type: "text",
                    className: "graph-settings-axis-label",
                    value: label.content,
                    onChange: this.onContentChange.bind(this, i)
                })
            ),
            React.createElement(
                "td",
                null,
                React.createElement(
                    "select",
                    {
                        className: "perseus-widget-dropdown",
                        value: label.alignment,
                        onChange: this.onAlignmentChange.bind(this, i)
                    },
                    captionAlignments.map(function (alignment, i) {
                        return React.createElement(
                            "option",
                            { key: "" + i, value: alignment },
                            alignment
                        );
                    }, this)
                )
            ),
            React.createElement(
                "td",
                null,
                React.createElement(
                    "a",
                    {
                        href: "#",
                        className: "simple-button orange delete-label",
                        title: "Remove this label",
                        onClick: this.removeLabel.bind(this, i)
                    },
                    React.createElement(InlineIcon, iconTrash)
                )
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    removeLabel: function removeLabel(labelIndex, e) {
        e.preventDefault();
        var labels = _(this.props.labels).clone();
        labels.splice(labelIndex, 1);
        this.props.onChange({ labels: labels });
    },

    onCoordinateChange: function onCoordinateChange(labelIndex, newCoordinates) {
        var labels = this.props.labels.slice();
        labels[labelIndex] = _.extend({}, labels[labelIndex], {
            coordinates: newCoordinates
        });
        this.props.onChange({ labels: labels });
    },

    onContentChange: function onContentChange(labelIndex, e) {
        var newContent = e.target.value;
        var labels = this.props.labels.slice();
        labels[labelIndex] = _.extend({}, labels[labelIndex], {
            content: newContent
        });
        this.props.onChange({ labels: labels });
    },

    onAlignmentChange: function onAlignmentChange(labelIndex, e) {
        var newAlignment = e.target.value;
        var labels = this.props.labels.slice();
        labels[labelIndex] = _.extend({}, labels[labelIndex], {
            alignment: newAlignment
        });
        this.props.onChange({ labels: labels });
    },

    setUrl: function setUrl(url, width, height, silent) {
        // Because this calls into WidgetEditor._handleWidgetChange, which
        // checks for this widget's ref to serialize it.
        //
        // Errors if you switch items before the `Image` from `onUrlChange`
        // loads.
        if (!this.isMounted()) {
            return;
        }

        var image = _.clone(this.props.backgroundImage);
        image.url = url;
        image.width = width;
        image.height = height;
        var box = [image.width, image.height];
        this.props.onChange({
            backgroundImage: image,
            box: box
        }, null, silent);
    },

    // silently load the image when the component mounts
    // silently update url and sizes when the image loads
    // noisily load the image in response to the author changing it
    onUrlChange: function onUrlChange(url, silent) {
        var _this3 = this;

        // All article content must be KA-owned!
        if (!INTERNALLY_HOSTED_URL_RE.test(url)) {
            this.setState({
                backgroundImageError: "Images must be from sites hosted by Khan Academy. " + "Please input a Khan Academy-owned address, or use the " + "Add Image tool to rehost an existing image"
            });
            return;
        } else {
            this.setState({ backgroundImageError: "" });
        }

        // We update our background image prop after the image loads below. To
        // avoid weirdness when we change to a very slow URL, then a much
        // faster URL, we keep track of the URL we're trying to change to.
        this._leadingUrl = url;

        if (!url) {
            this.setUrl(url, 0, 0, silent);
            return;
        }

        Util.getImageSize(url, function (width, height) {
            if (_this3._leadingUrl !== url) {
                return;
            }

            _this3.setUrl(url, width, height, true);
        });
    },

    onRangeChange: function onRangeChange(type, newRange) {
        var range = this.props.range.slice();
        range[type] = newRange;
        this.props.onChange({ range: range });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = ImageEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/image-editor.jsx
 ** module id = 115
 ** module chunks = 0 1
 **/